import { CallMade, MoreHoriz, Search } from "@mui/icons-material";
import { Avatar, Box, Chip, Grid, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import Api from "src/services/api";
import { PapiroConsole } from "src/utils/papiroConsole";
import { calledExists, calledExistsAll, searchById, searchAllById } from "src/services/called.service";
import './item-card.css';
import moment from "moment";

const CalledCard = (props) => {
    const { called, isAdm, isClient, intl, history, lang, setNotification, setLoading, archived } = props;
    const theme = useTheme();

    const opening = moment(called.openingdate).format("DD/MM/YYYY")
    const openingHour = moment(called.openingdate).format("HH:mm")
    const dueDt = moment(called.duedate).format("DD/MM/YYYY")
    const dueHour = moment(called.duedate).format("HH:mm")
    const solutionDt = moment(called.solutiondate).format("DD/MM/YYYY")
    const solutionHour = moment(called.solutiondate).format("HH:mm")

    const [showId, setShowId] = useState(false)
    const [showcalledtitle, setShowcalledtitle] = useState(false)
    const [showcalledrequester, setShowcalledrequester] = useState(false)
    const [showcalledassigner, setShowcalledassigner] = useState(false)
    const [showcalledopendate, setShowcalledopendate] = useState(false)
    const [showcalledduedate, setShowcalledduedate] = useState(false)
    const [showcalledsolutiondate, setShowcalledsolutiondate] = useState(false)
    const [showcalledslaserviceexpired, setShowcalledslaserviceexpired] = useState(false)
    const [displayassignedinfomode, setdisplayassignedinfomode] = useState(1)

    useEffect(() => {
        ruleTableList()
    }, [called])

    const ruleTableList = () => {
        if (isAdm) {
            if (called && called.calledlistdata != null) {
                setShowId(called.calledlistdata.calledid === true ? true : false)
                setShowcalledtitle(called.calledlistdata.calledtitle === true ? true : false)
                setShowcalledrequester(called.calledlistdata.calledrequester === true ? true : false)
                setShowcalledassigner(called.calledlistdata.calledassigner === true ? true : false)
                setdisplayassignedinfomode(called.organization && called.organization.organizationsettings ? called.organization.organizationsettings.displayassignedinfomode : 1)
                setShowcalledopendate(called.calledlistdata.calledopendate === true ? true : false)
                setShowcalledduedate(called.calledlistdata.calledduedate === true ? true : false)
                setShowcalledsolutiondate(true)
                setShowcalledslaserviceexpired(called.calledlistdata.calledslaserviceexpired === true ? true : false)
            } else {
                setShowId(true)
                setShowcalledtitle(true)
                setShowcalledrequester(true)
                setShowcalledopendate(true)
                setShowcalledduedate(true)
                setShowcalledsolutiondate(true)
                setShowcalledassigner(true)
                setdisplayassignedinfomode(called.organization && called.organization.organizationsettings ? called.organization.organizationsettings.displayassignedinfomode : 1)
                setShowcalledslaserviceexpired(false)
            }
        } else if (isAdm == false && isClient) {
            if (called && called.calledlistdata != null) {
                setShowId(called.calledlistdata.calledid === true ? true : false)
                setShowcalledtitle(called.calledlistdata.calledtitle === true ? true : false)
                setShowcalledrequester(called.calledlistdata.calledrequester === true ? true : false)
                setShowcalledassigner(called.calledlistdata.calledassigner === true ? true : false)
                setdisplayassignedinfomode(called.organization && called.organization.organizationsettings ? called.organization.organizationsettings.displayassignedinfomode : 1)
                setShowcalledopendate(called.calledlistdata.calledopendate === true ? true : false)
                setShowcalledduedate(called.calledlistdata.calledduedate === true ? true : false)
                setShowcalledsolutiondate(false)
            } else {
                setShowId(true)
                setShowcalledtitle(true)
                setShowcalledrequester(true)
                setShowcalledassigner(true)
                setdisplayassignedinfomode(called.organization && called.organization.organizationsettings ? called.organization.organizationsettings.displayassignedinfomode : 1)
                setShowcalledopendate(false)
                setShowcalledduedate(false)
                setShowcalledsolutiondate(false)
            }
        } else {
            if (called && called.calledlistdata != null) {
                setShowId(called.calledlistdata.calledid === true ? true : false)
                setShowcalledtitle(called.calledlistdata.calledtitle === true ? true : false)
                setShowcalledrequester(called.calledlistdata.calledrequester === true ? true : false)
                setShowcalledassigner(called.calledlistdata.calledassigner === true ? true : false)
                setdisplayassignedinfomode(called.organization && called.organization.organizationsettings ? called.organization.organizationsettings.displayassignedinfomode : 1)
                setShowcalledopendate(called.calledlistdata.calledopendate === true ? true : false)
                setShowcalledduedate(called.calledlistdata.calledduedate === true ? true : false)
                setShowcalledsolutiondate(true)
            } else {
                setShowId(true)
                setShowcalledduedate(true)
                setShowcalledsolutiondate(true)
                setShowcalledtitle(true)
                setShowcalledrequester(true)
                setShowcalledopendate(true)
                setShowcalledassigner(true)
                setdisplayassignedinfomode(called.organization && called.organization.organizationsettings ? called.organization.organizationsettings.displayassignedinfomode : 1)
            }
        }
    }

    const consultCalled = async () => {

        setLoading(true)
        let response = null;
        if(archived){
            response = await searchAllById(called.id)
        }
        else{
            response = await searchById(called.id)
        }
        if (
            response != null &&
            response.success != null &&
            response.success &&
            response.data != null &&
            response.data
        ) {
            setLoading(false)
            if(archived){
                history.push(`/${lang}/called-view-archived/${called.id}`)
            }
            else{
                history.push(`/${lang}/called-view/${called.id}`)
            }
        } else {
            setLoading(false)
            const notification = response &&
                response.response &&
                response.response.data &&
                response.response.data.errors &&
                response.response.data.errors[0]
                ? response.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" })
            setNotification("error", notification)

            Api.kickoff(response)
        }
    }

    const goToCalled = async (newTab = false) => {
        setLoading(true)
        let result = await calledExistsAll(called.id);
        if (result.success) {
            setLoading(false)
            if (
                result.data != null &&
                typeof result.data !== "undefined" &&
                result.data === true
            ) {
                if (!newTab) {
                    //alert(archived);
                    if(archived){
                        history.push(`/${lang}/called-accompaniment/${called.id}?archived=true`);
                    }
                    else{
                        history.push(`/${lang}/called-accompaniment/${called.id}`);
                    }
                    if (
                        history &&
                        history.location &&
                        history.location &&
                        history.location.pathname &&
                        history.location.pathname.length > 0
                    ) {
                        let pathList = history.location.pathname.split("/")
                        if (pathList && pathList.length >= 2) {
                            if (pathList[2] == "called-accompaniment") {
                                window.location.reload();
                            }
                        }
                    }
                } else {
                    if(archived){
                        window.open(`${window.location.origin}/${lang}/called-accompaniment/${called.id}?archived=true`,"_blank","noopener,noreferrer")
                    }
                    else{
                        window.open(`${window.location.origin}/${lang}/called-accompaniment/${called.id}`,"_blank","noopener,noreferrer")
                    }
                }
            } else {
                setLoading(false)
                setNotification("error", intl.formatMessage({ id: "called.does.not.exist" }))
            }
        } else {
            setLoading(false)
            const notification = result.response &&
                result.response.data &&
                result.response.data.errors
                ? result.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" })
            setNotification("error", notification)
            Api.kickoff(result)
        }
    }

    const conditionRequestinguser = called?.requestinguser != null && called?.requestinguser != '' && called?.requestinguser != undefined;

    const primaryColor = theme.palette.primary.main

    return (
        <Grid item container lg={12} md={12} sm={12} xs={12} className='cardItem' direction="row" alignItems="center">
            {showcalledrequester && (<Grid item lg={2} md={1} sm={3} xs={3} className='requestinguser'>
                <Grid container spacing={0} direction="column">
                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                        <Avatar alt={called.requestinguser}>
                            {conditionRequestinguser ? called?.requestinguser.charAt(0) : ''}
                        </Avatar>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                        <span>{conditionRequestinguser? called?.requestinguser : ''}</span>
                    </Grid>
                </Grid>
            </Grid>)}
            <Grid item lg={1} md={2} className='moreActions'>
                <Tooltip title={<h5>Nova guia</h5>}>
                    <IconButton aria-label="call-made" onClick={() => goToCalled(true)}>
                        <CallMade />
                    </IconButton>
                </Tooltip>
                <Tooltip title={<h5>{intl.formatMessage({ id: "consult.called" })}</h5>}>
                    <IconButton aria-label="table-popup" onClick={() => consultCalled()} >
                        <Search />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item container spacing={2} lg={6} md={6} sm={7} xs={7} direction="row">
                {(showId || showcalledtitle) && (<Grid item className='boldLine-two' onClick={() => goToCalled(false)} style={{ cursor: 'pointer' }}>
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5}>
                        {showId && <span>ID {called.id}</span>}
                        {(showId && showcalledtitle) && <span> | </span>}
                        {showcalledtitle && <span>{called.title}</span>}
                        {(() => {
                            const tags = called.tags ? called.tags.split(',').filter(Boolean) : []
                            if (tags.length === 0) return null
                            const MAX_VISIBLE = 3
                            const visible = tags.slice(0, MAX_VISIBLE)
                            const hidden = tags.slice(MAX_VISIBLE)
                            return (
                                <>
                                    <span style={{ marginLeft: 2 }}> | </span>
                                    {visible.map((tag, i) => {
                                        const chip = <Chip key={i} label={tag.length > 50 ? tag.slice(0, 50) + '…' : tag} size="small" sx={{ height: 20, fontSize: 11, bgcolor: primaryColor, color: '#fff' }} onClick={e => e.stopPropagation()} />
                                        return tag.length > 50 ? <Tooltip key={i} title={tag}>{chip}</Tooltip> : chip
                                    })}
                                    {hidden.length > 0 && (
                                        <Tooltip
                                            title={
                                                <Box display="flex" flexWrap="wrap" gap={0.5} p={0.5}>
                                                    {hidden.map((tag, i) => (
                                                        <Chip key={i} label={tag.length > 50 ? tag.slice(0, 50) + '…' : tag} title={tag.length > 50 ? tag : undefined} size="small" sx={{ bgcolor: primaryColor, color: '#fff', height: 20, fontSize: 11 }} />
                                                    ))}
                                                </Box>
                                            }
                                        >
                                            <Chip
                                                icon={<MoreHoriz style={{ fontSize: 14, color: primaryColor }} />}
                                                label={`+${hidden.length}`}
                                                size="small"
                                                variant="outlined"
                                                sx={{ height: 20, fontSize: 11, color: primaryColor, borderColor: primaryColor }}
                                                onClick={e => e.stopPropagation()}
                                            />
                                        </Tooltip>
                                    )}
                                </>
                            )
                        })()}
                    </Box>
                </Grid>)}
                {(showcalledassigner || showcalledopendate || showcalledslaserviceexpired) && (<Grid item className='lightLine' style={{ lineHeight: '25px' }}>
                    {(showcalledassigner && (displayassignedinfomode == 1 || (!isClient && displayassignedinfomode == 2))) && (<span>{called.assigneduser && called.assigneduser.length > 0 ? called.assigneduser + " -" : ""}  </span>)}
                    {(showcalledassigner && (isClient && displayassignedinfomode == 2) || displayassignedinfomode == 4) && (<span>{called.techinicalteam ? called.techinicalteam.name + " - " : null}</span>)}
                    {(showcalledassigner && showcalledopendate && called.assigneduser && called.assigneduser.length > 0)}
                    {showcalledopendate && (<span>{intl.formatMessage({ id: "open.date" })} {opening} | {openingHour}</span>)}
                    {(showcalledduedate && showcalledopendate) && (<span> - </span>)}
                    {showcalledduedate && (<span>{intl.formatMessage({ id: "estimated.solution.date" })} {dueDt} | {dueHour}</span>)}
                    {(showcalledduedate && showcalledsolutiondate && called.solutionDt != null) && (<span> - </span>)}
                    {(showcalledsolutiondate && called.solutionDt != null) && (<span>{intl.formatMessage({ id: "solution.date" })} {solutionDt} | {solutionHour}</span>)}
                    {(showcalledslaserviceexpired && called.service >= 100) && (<span style={{
                        marginLeft: 10,
                        border: '1px solid rgba(243, 32, 42)',
                        padding: '8px 5px',
                        color: 'rgb(243, 32, 42)',
                        borderRadius: 15
                    }}>{intl.formatMessage({ id: "expired" })}</span>)}
                </Grid>)}
            </Grid>
        </Grid>
    )
}

export default CalledCard